<div class="container-fluid p-4">
    <div class="row mb-5 g-3">
        <div class="col-4">
            <div class="row">
                <ngx-skeleton-loader count="1" [theme]="{
                    height: '50px',
                    width: '450px'
                }" />
            </div>
            <div class="row">
                <ngx-skeleton-loader count="1" [theme]="{
                    height: '300px',
                    width: '450px'
                }" />
            </div>
        </div>
        <div class="col-4">
            <div class="row">
                <ngx-skeleton-loader count="1" [theme]="{
                    height: '50px',
                    width: '450px'
                }" />
            </div>
            <div class="row">
                <ngx-skeleton-loader count="1" [theme]="{
                    height: '300px',
                    width: '450px'
                }" />
            </div>
        </div>
        <div class="col-4">
            <div class="row">
                <ngx-skeleton-loader count="1" [theme]="{
                    height: '50px',
                    width: '450px'
                }" />
            </div>
            <div class="row">
                <ngx-skeleton-loader count="1" [theme]="{
                    height: '300px',
                    width: '450px'
                }" />
            </div>
        </div>
    </div>
</div>